import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCommentSocket } from "../context/SocketContext";
import { FaRegComment, FaTimes } from "react-icons/fa";

const BANNER_TIMEOUT = 10000; // Auto-dismiss after 10 seconds

const EngagementBanner = ({ userPostIds = [], condition }) => {
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null); // { messageId, count }
  const timeoutRef = useRef(null);
  const seenPostsRef = useRef(new Set());

  const clearBanner = useCallback(() => {
    setBanner(null);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const handleNewComment = useCallback(
    (comment) => {
      const messageId = comment.messageId;
      if (!messageId || !userPostIds.includes(messageId)) return;
      if (seenPostsRef.current.has(messageId)) return;

      seenPostsRef.current.add(messageId);
      setBanner({ messageId });

      // Auto-dismiss
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(clearBanner, BANNER_TIMEOUT);
    },
    [userPostIds, clearBanner]
  );

  useCommentSocket(handleNewComment);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  if (!banner) return null;

  return (
    <div className="fixed top-16 lg:top-4 left-1/2 -translate-x-1/2 z-50 animate-fadeIn">
      <div className="bg-spiders-bg-elevated border border-spiders-primary-500/30 rounded-xl shadow-lg px-5 py-3 flex items-center space-x-3">
        <FaRegComment className="w-4 h-4 text-spiders-primary-400 flex-shrink-0" />
        <span className="text-sm text-spiders-text-primary">
          Your post is getting responses!
        </span>
        <button
          onClick={() => {
            clearBanner();
            navigate(`/messages/${banner.messageId}?condition=${condition}`);
          }}
          className="text-xs text-spiders-primary-400 hover:text-spiders-primary-300 font-medium whitespace-nowrap"
        >
          View thread &rarr;
        </button>
        <button
          onClick={clearBanner}
          className="text-spiders-text-muted hover:text-spiders-text-primary p-0.5 rounded-full transition-colors"
        >
          <FaTimes className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default EngagementBanner;
